import type { ReceiptScanJob } from './types.ts'

/** No vision-model key on this installation: a FAILED job with this code, not a failed scan. */
export function isAiNotConfigured(job: ReceiptScanJob): boolean {
  return job.status === 'FAILED' && job.failureCode === 'AI_UNAVAILABLE'
}

/** A successful scan can never be deleted - only a `FAILED` job's own review screen offers it. */
export function isDeletable(job: ReceiptScanJob): boolean {
  return job.status === 'FAILED'
}
